/**
 * 📷 **경주 카드에서 AR 로 넘어가는 길** — 주소를 만드는 곳.
 *
 * 🔴 맵 오브젝트에는 `ar_scene`(예: `ar_chumseongdae`)이 예전부터 적혀 있었고, 문서(02 §3)와
 * `ContentObject` 타입에도 있었다. **그런데 웹은 그 값을 어디에서도 읽지 않았다** — 실측:
 * `ar_scene` 을 쓰는 곳 0. 경주 5대 유산 카드를 열면 「길찾기」·「여기서 인증」만 있고 AR 로
 * 가는 길이 없었다. 운영자가 맵에 적어 둔 것이 조용히 아무 일도 안 한 것이다.
 *
 * 🔴 **볼 게 있나는 여기서 다시 정하지 않는다.** 그 판정은 이미 `arSceneReady`(arGroup)에
 * 있다 — 카메라가 알아볼 그림(.mind)이나 대신 볼 영상이 있을 때만 참. 여기서 「포스터라도
 * 있으면 보여 주자」로 새로 짜면 **막다른 길이 돌아온다**(그 주석이 겪은 그대로).
 */

/**
 * 장면 id 검증 — 외부(맵·콘텐츠) 값이므로 그대로 주소에 넣지 않는다(불변식 7).
 * 책 페이지 AR 은 `<책id>.<쪽id>` 라 **점이 들어간다** — 점을 막으면 책 AR 이 끊긴다.
 */
const ID_OK = /^[A-Za-z0-9._-]{1,64}$/;

export function isArSceneId(v: unknown): v is string {
  return typeof v === "string" && ID_OK.test(v);
}

/** 맵의 `ar_scene` → `/ar?scene=…` 딥링크. 이상한 값이면 `undefined`(길을 안 낸다). */
export function arSceneHref(id: unknown): string | undefined {
  return isArSceneId(id) ? `/ar?scene=${encodeURIComponent(id)}` : undefined;
}

/** 단추 글 — 아이가 무엇을 하게 되는지 그대로 말한다. */
export const AR_CARD_SAY = "📷 AR로 보기";
